import { render, staticRenderFns } from "./serviceTabs.vue?vue&type=template&id=ce73453e&scoped=true"
import script from "./serviceTabs.vue?vue&type=script&lang=js"
export * from "./serviceTabs.vue?vue&type=script&lang=js"
import style0 from "./serviceTabs.vue?vue&type=style&index=0&id=ce73453e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce73453e",
  null
  
)

export default component.exports